import Dexie from "dexie";
const AISEA_DB_NAME = "aiseaLocalStorageDb"
const db = new Dexie(AISEA_DB_NAME);

export default {
  init() {
    db.version(1).stores({
      auth: "id, idToken, refreshToken, user, *addons, rememberIds, updated_at",
      monitoring_vessels: "id, *vessel_ids, updated_at",
      settings:"id, default_position, map_style"
    });
    db.version(2).stores({
      auth: "id, idToken, refreshToken, user, *addons, rememberIds, updated_at",
      monitoring_vessels: "id, *vessel_ids, updated_at",
      settings:"id, default_position, map_style",
      voyage_history_timeline_data: `id, myVesselPoint, myVesselInfo, myVesselWakes, pointFeatures, polygonFeatures`
    });
    db.version(3).stores({
      auth: "id, idToken, refreshToken, user, *addons, rememberIds, updated_at",
      monitoring_vessels: "id, *vessel_ids, updated_at",
      settings:"id, default_position, map_style",
      voyage_history_timeline_data: `id, myVesselPoint, myVesselInfo, myVesselWakes, pointFeatures, polygonFeatures`,
      live_map_vessels: `id, pos_before, pos, info, time, into_timeout`
    });
    db.version(4).stores({
      auth: "id, idToken, refreshToken, user, *addons, rememberIds, updated_at",
      monitoring_vessels: "id, *vessel_ids, updated_at",
      settings:"id, default_position, map_style, own_vessel_display_duration_time",
      voyage_history_timeline_data: `id, myVesselPoint, myVesselInfo, myVesselWakes, pointFeatures, polygonFeatures`,
      live_map_vessels: `id, pos_before, pos, info, time, into_timeout`,
      filters: "id, filter_values",
    });
    db.version(5).stores({
      auth: "id, idToken, refreshToken, user, *addons, rememberIds, updated_at",
      monitoring_vessels: "id, *vessel_ids, updated_at",
      settings:"id, default_position, map_style, own_vessel_display_duration_time",
      voyage_history_timeline_data: `id, myVesselPoint, myVesselInfo, myVesselWakes, pointFeatures, polygonFeatures`,
      live_map_vessels: `id, pos_before, pos, info, time, into_timeout`,
      filters: "id, filter_values",
      channels_data: "channel_id, *point_data",
    });
    db.version(6).stores({
      auth: "id, idToken, refreshToken, user, *addons, rememberIds, updated_at",
      monitoring_vessels: "id, *vessel_ids, updated_at",
      settings:"id, default_position, map_style, own_vessel_display_duration_time, left_menu_reduce_state",
      voyage_history_timeline_data: `id, myVesselPoint, myVesselInfo, myVesselWakes, pointFeatures, polygonFeatures`,
      live_map_vessels: `id, pos_before, pos, info, time, into_timeout`,
      filters: "id, filter_values",
      channels_data: "channel_id, *point_data",
    });
    db.version(7).stores({
      auth: "id, idToken, refreshToken, user, *addons, rememberIds, updated_at, isFree",
      monitoring_vessels: "id, *vessel_ids, updated_at",
      settings:"id, default_position, map_style, own_vessel_display_duration_time, left_menu_reduce_state",
      voyage_history_timeline_data: `id, myVesselPoint, myVesselInfo, myVesselWakes, pointFeatures, polygonFeatures`,
      live_map_vessels: `id, pos_before, pos, info, time, into_timeout`,
      filters: "id, filter_values",
      channels_data: "channel_id, *point_data",
    });
  },
  getInstance() {
    return db;
  },

  isExists() {
    return Dexie.exists(AISEA_DB_NAME);
  }
};
